import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
const painPoints = [{
  title: 'Te despertás a las 2 AM con el corazón desbocado',
  desc: 'Sin saber si es una crisis leve o si tenés que correr a la guardia.',
  emoji: '😰'
}, {
  title: 'Termina siempre en la guardia',
  desc: 'Sin importar cuánto lo cuidés, el ciclo de crisis y guardia se repite cada pocas semanas.',
  emoji: '🏥'
}, {
  title: 'Limpiás y limpiás pero igual tiene crisis',
  desc: 'Sin saber que los productos que usás para limpiar su cuarto son uno de los principales disparadores.',
  emoji: '😤'
}, {
  title: 'No sabés qué tiene que comer',
  desc: 'Sin información sobre qué alimentos inflan sus bronquios desde adentro.',
  emoji: '🍕'
}, {
  title: 'Le prohibís el deporte por miedo',
  desc: 'Sin saber que la inactividad empeora el asma y que hay un protocolo específico para que pueda jugar sin riesgo.',
  emoji: '🎽'
}, {
  title: 'Cada crisis te genera culpa',
  desc: 'Sin entender que la medicación que le da vida también tiene un costo metabólico que podés gestionar.',
  emoji: '💊'
}, {
  title: 'El colegio no sabe qué hacer con él',
  desc: 'Sin un manual claro que le explique al maestro exactamente cómo protegerlo durante las 6 horas que no estás.',
  emoji: '📚'
}, {
  title: 'Cada invierno es una pesadilla',
  desc: 'Sin un mapa de anticipación que te diga cuándo vienen los meses de mayor riesgo y cómo prepararte antes.',
  emoji: '📅'
}];
export const PainPoints = () => {
  return <section className="py-10 sm:py-14 md:py-20 bg-cream" data-id="element-207">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-208">
        <div className="text-center mb-6 sm:mb-10" data-id="element-209">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-3 sm:mb-4" data-id="element-210">
            ¿TE PASA ESTO?
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600" data-id="element-211">
            Si tenés un hijo asmático en Argentina, esto te suena familiar:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 md:gap-6" data-id="element-212">
          {painPoints.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35,
          delay: i * 0.05
        }} className="flex gap-3 sm:gap-4 bg-white p-4 sm:p-5 md:p-6 rounded-xl shadow-sm border border-red-100" data-id="element-213">
              <div className="flex-shrink-0 mt-1 text-xl sm:text-2xl" data-id="element-214">
                {pain.emoji}
              </div>
              <div data-id="element-215">
                <h3 className="font-bold text-gray-900 mb-1 text-sm sm:text-base" data-id="element-216">
                  {pain.title}
                </h3>
                <p className="text-gray-600 text-xs sm:text-sm leading-relaxed" data-id="element-217">
                  {pain.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-10 sm:mt-14 md:mt-16 text-center" data-id="element-218">
          <p className="text-xl sm:text-2xl md:text-3xl font-heading font-bold text-brand-orange px-4" data-id="element-219">
            ¿Cuántos inviernos más vas a pasar sin un sistema?
          </p>
        </motion.div>
      </div>
    </section>;
};